import { FormikValues } from 'formik';

import { CMSFilterType } from '../../../../models/cms-placeholder.model';

export const getCMSFiltersMappedValues = (values: FormikValues) =>
    values?.cms_filter_type === CMSFilterType.SPECIFIC
        ? (values?.cms_filters ?? []).filter(
              (filter: any) =>
                  filter.cms_placeholder_id && filter.operator && filter.value,
          )
        : [];
